import React from "react";
import MaterialReactTable from 'material-react-table';
import type { MRT_ColumnDef } from 'material-react-table';

import {
    Box,
    IconButton,
    Stack
} from "@mui/material";

import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from "@mui/icons-material/Edit";

import {AwardTableProps, AwardTableState} from "./models";

import { Award } from "models";

import { t } from "@lingui/macro";
import { WithSnackbarProps, withSnackbar } from "notistack";
import {ConfirmModal} from "../../../../commons/modal/confirm-modal";



class AwardTable extends React.Component<AwardTableProps & WithSnackbarProps, AwardTableState>
{
    private tableColumns: MRT_ColumnDef[];

    public constructor(props: any) {

        super(props)


        this.state={
            openConfirmModal: false,
            awardToDelete: ""
        }

        this.tableColumns = [
            {
                header: t({
                    id: "at-table-col-title",
                    message: "Nome premio"
                }),
                accessorKey: "value",
                Cell: ({ cell }) => {
                    return (
                        <Box>
                            {cell.getValue<string>()}
                        </Box>
                    );
                },
            },
        ];
    }

    private openConfirmModal = (id: string) : void =>{
        this.setState(() => ({
            openConfirmModal: true,
            awardToDelete: id
        }))
    }

    private cancelConfirmModalCallback = () : void =>{
        this.setState(() => ({
            openConfirmModal: false,
            awardToDelete: ""
        }))
    }

    private acceptConfirmModal = () : void =>{
        this.setState(() => ({
            openConfirmModal: false,
        }))
        this.deleteAward()
    }



    private deleteAward = (): void => {
        this.props.deleteAward(this.state.awardToDelete);
        this.setState(() => ({
            awardToDelete: ""
        }))
    }

    private getIdValue = (row: any): string => {
        return row.original.id
    }

    private openEditModal = (award: any) => {
        this.props.openEditAwardTable(award as Award);
    }

    private handlePageChange = (updateFn: any) => {
        let newPagination = updateFn(this.props.pagination);
        this.props.updatePaginationCallBackFn(newPagination);
    }  

    render() {
        return (
            <>
            <Box style={{ maxWidth: '100%' }}>
                <MaterialReactTable
                    columns={this.tableColumns}
                    rowCount={this.props.totalAwardCount}
                    pageCount={Math.ceil(this.props.totalAwardCount / this.props.pagination.pageSize)}
                    data={this.props.awards}
                    enableRowSelection={false}
                    enableColumnOrdering={false}
                    enableColumnActions={false}
                    enableGlobalFilter={false}
                    enableFilters={false}
                    muiTableHeadCellProps={{
                        sx: {
                            color: "white",
                            backgroundColor: process.env.REACT_APP_PRIMARY_COLOR
                        }
                    }}
                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            header: ""
                        }
                    }}
                    enableRowActions
                    positionActionsColumn="last"
                    renderRowActions={({ row }) => (
                        <Stack direction={"row"} display={"flex"} justifyContent={"right"} >
                            <IconButton onClick={() => this.openEditModal(row.original)}>
                                <EditIcon />
                            </IconButton>
                            <IconButton onClick={() => this.openConfirmModal(this.getIdValue(row))}>
                                <DeleteIcon />
                            </IconButton>
                        </Stack>
                    )}
                    onPaginationChange={this.handlePageChange}
                    enableTopToolbar={false}
                    manualPagination={true}
                    autoResetPageIndex={false}
                    enableDensityToggle={false}
                    state={{
                        pagination: this.props.pagination
                    }} />
            </Box>
        {this.state.openConfirmModal && <ConfirmModal
            cancelConfirmCallback={this.cancelConfirmModalCallback}
            confirmCallback={this.acceptConfirmModal}
            text={"Sei sicuro di voler procedere con l'eliminazione del premio?"}
            textId={"at-delete-award-text"}
        />}
    </>)
    }
}

export default withSnackbar(AwardTable);